import React from 'react';
import './aboutUs.css'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import img1 from '../../assets/images/gallery/photo_1.png';
import img2 from '../../assets/images/gallery/photo_2.png';
import img3 from '../../assets/images/gallery/photo_3.png';
import img4 from '../../assets/images/gallery/photo_4.png';
import img5 from '../../assets/images/gallery/photo_5.png';
import img6 from '../../assets/images/gallery/photo_6.png';
import img7 from '../../assets/images/gallery/photo_7.png';
import img8 from '../../assets/images/gallery/photo_8.png';
import img9 from '../../assets/images/gallery/photo_9.png';

export default function AboutUs() {

  const sliderRef = React.useRef(null);

  const settings = {
    autoplay:true,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplaySpeed: 3000,
    arrows: false,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 760, // для экранов < 761 px
        settings: {
          slidesToShow: 1,      // показываем 1 слайд
          slidesToScroll: 1,   // прокручиваем 1 слайд
          arrows: false,        // включаем стрелки навигации
          dots: false          // оставляем точки‑индикаторы
        }
      }
    ]
  };

  const images = [img1, img2, img3, img4, img5, img6, img7, img8, img9];

  const next = () => {
    sliderRef.current.slickNext();
  };

  const prev = () => {
    sliderRef.current.slickPrev();
  };

  return (
    <section id="o-nas" className="aboutUs-section">
      <div className="aboutUs-container">
        <h2 className="aboutUs-title">О нас</h2>
        <div className="aboutUs-card">
          <p>
            ООО «Характер металла» — современное производство металлических изделий с полным циклом обработки.
            Мы работаем с металлом любой сложности и предлагаем полный спектр услуг, от разработки конструкторской
            документации до производства готовых изделий. Используя передовые технологии и современное оборудование,
            наша компания готова реализовать даже самые сложные и нестандартные проекты.
          </p>
          <p>
            Мы предлагаем как серийное производство, так и выполнение уникальных заказов с учётом всех особенностей
            и пожеланий заказчика. Это делает нас гибкими и способными находить решения даже в самых сложных ситуациях.
          </p>
          <p>
            В лице нашей компании вы найдёте надёжного и ответственного партнёра для долгосрочного сотрудничества.
          </p>
        </div>

        <div className="aboutUs-slider-wrapper">
          <div className="slider-container">
            <button
              className="slider-btn slider-btn-prev"
              onClick={prev}
            >
              ‹
            </button>

            <Slider {...settings} ref={sliderRef}>
              {images.map((src, index) => (
                <div key={index}>
                  <img
                    src={src}
                    alt={`Фото производства ${index + 1}`}
                    className="aboutUs-image"
                  />
                </div>
              ))}
            </Slider>

            <button
              className="slider-btn slider-btn-next"
              onClick={next}
            >
              ›
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}